import { gsap } from 'gsap';

export const fadeIn = (element: HTMLElement, duration: number = 0.5, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, duration, delay, ease: 'power2.out' }
  );
};

export const slideInLeft = (element: HTMLElement, duration: number = 0.5, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, x: -50 },
    { opacity: 1, x: 0, duration, delay, ease: 'power2.out' }
  );
};

export const slideInRight = (element: HTMLElement, duration: number = 0.5, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, x: 50 },
    { opacity: 1, x: 0, duration, delay, ease: 'power2.out' }
  );
};

export const scaleIn = (element: HTMLElement, duration: number = 0.5, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, scale: 0.8 },
    { opacity: 1, scale: 1, duration, delay, ease: 'back.out(1.7)' }
  );
};

export const staggerFadeIn = (elements: HTMLElement[], duration: number = 0.5, stagger: number = 0.1) => {
  return gsap.fromTo(
    elements,
    { opacity: 0, y: 20 },
    { opacity: 1, y: 0, duration, stagger, ease: 'power2.out' }
  );
};

export const bounceIn = (element: HTMLElement, duration: number = 0.8, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, scale: 0 },
    { opacity: 1, scale: 1, duration, delay, ease: 'bounce.out' }
  );
};

export const rotateIn = (element: HTMLElement, duration: number = 0.5, delay: number = 0) => {
  return gsap.fromTo(
    element,
    { opacity: 0, rotation: -180 },
    { opacity: 1, rotation: 0, duration, delay, ease: 'power2.out' }
  );
};

export const typewriter = (element: HTMLElement, text: string, speed: number = 0.05) => {
  const tl = gsap.timeline();
  element.textContent = '';
  
  const chars = text.split('');
  chars.forEach((char, index) => {
    tl.to(element, {
      duration: speed,
      onComplete: () => {
        element.textContent += char;
      }
    }, index * speed);
  });
  
  return tl;
};